import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article8Doc } from '../individual';

export default function Article8() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article8Doc />
        <Footer />
    </div>
  )
}
